import { ParseExportFailure } from "../utils/ParseExportFailure";
import { QRFC } from "./QRFC";

export class QCreateSVGRFC extends QRFC {
  constructor() {
    super();
    this.fHIRESPNG = false;
  }

  InitCreateSVGRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", false, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qcreatesvg";
  }

  SetHIRESPNG(HIRESPNG) {
    this.fHIRESPNG = HIRESPNG;
  }

  DoTransactionComplete(response, callBackObj) {
    var r = response;
    var failure = ParseExportFailure(r);
    var svgFile = "";
    var altFile = "";

    if (failure == null) {
      var response = r.split(":");
      svgFile = response[0];
      altFile = null;
      if (response.length > 1) altFile = response[1];
    }

    callBackObj.SVGResult(failure, svgFile, altFile, this.fHIRESPNG);
  }
}
